exports.PasswordStrengthBarModule = require('./lib/passwordStrengthBar.module').PasswordStrengthBarModule;
exports.PasswordStrengthBarComponent = require('./lib/passwordStrengthBar.component').PasswordStrengthBarComponent;



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/ng2-password-strength-bar/index.js
// module id = ../../../../ng2-password-strength-bar/index.js
// module chunks = 4